import type { DeleteManagementResponse } from '@/domains/academicRisk/academicRiskManagement.entity';
import type { AcademicRiskManagementRepository } from '@/domains/academicRisk/academicRiskManagement.repository';

/**
 * Use Case para eliminar una gestión de riesgo académico existente
 *
 * Responsabilidades:
 * - Validar y ejecutar la eliminación de gestiones de riesgo académico
 * - Coordinar con el repositorio para eliminar los datos
 */
export class DeleteAcademicRiskManagementUseCase {
  private repository: AcademicRiskManagementRepository;

  /**
   * Inicializa el UseCase con el repositorio necesario
   * @param repository - Repositorio para operaciones de gestión de riesgo académico
   */
  constructor(repository: AcademicRiskManagementRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la eliminación de una gestión de riesgo académico
   * @param cod_ejecucion - Código de ejecución de la gestión a eliminar
   * @throws Error si la eliminación falla
   */
  async execute(cod_ejecucion: number): Promise<DeleteManagementResponse> {
    return await this.repository.deleteManagement(cod_ejecucion);
  }
}
